import { render, staticRenderFns } from "./KnFormSubject.vue?vue&type=template&id=7126239f"
import script from "./KnFormSubject.js?vue&type=script&lang=js&external"
export * from "./KnFormSubject.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports